/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerGetCitiesQueryResponse,
  TelegramGeoControllerGetCitiesPathParams,
} from '../../types/TelegramGeoControllerGetCities.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetCities } from '../../methods/telegramGeoGetCities.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetCitiesQueryKey = (regionId: TelegramGeoControllerGetCitiesPathParams['regionId']) =>
  [{ url: '/api/telegram/geo/cities/:regionId', params: { regionId: regionId } }] as const;

export type TelegramGeoGetCitiesQueryKey = ReturnType<typeof telegramGeoGetCitiesQueryKey>;

export function telegramGeoGetCitiesQueryOptions(
  regionId: TelegramGeoControllerGetCitiesPathParams['regionId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetCitiesQueryKey(regionId);
  return queryOptions<
    TelegramGeoControllerGetCitiesQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetCitiesQueryResponse,
    typeof queryKey
  >({
    enabled: !!regionId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetCities(regionId, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/cities/:regionId}
 */
export function useTelegramGeoGetCities<
  TData = TelegramGeoControllerGetCitiesQueryResponse,
  TQueryData = TelegramGeoControllerGetCitiesQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetCitiesQueryKey,
>(
  regionId: TelegramGeoControllerGetCitiesPathParams['regionId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetCitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetCitiesQueryKey(regionId);

  const query = useQuery(
    {
      ...telegramGeoGetCitiesQueryOptions(regionId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
